module.exports = __webpack_public_path__ + "img/side-hdgz.6faf333a.png";